export default "__VITE_ASSET__DT4Cf1fj__"